/*global ajaxPath */
import $ from 'jquery';

const listingFilters = {
  titleFilter: ['all-titles'],
  listingElementList: [],
  sending: false,

  initFilter: (filterName) => {
    // Get filter and listing elements
    const filterElementList = document.querySelectorAll(`.${filterName}-filter li`);

    if (filterName === 'title') {
      const listingElementList = document.querySelectorAll('.team-listing-block .team-member');
      listingElementList.forEach((listingElement) => {
        listingFilters.listingElementList.push(listingElement);
      });
    } else {
      const listingElementList = document.querySelectorAll('.post-listing .news-item');
      listingElementList.forEach((listingElement) => {
        listingFilters.listingElementList.push(listingElement);
      });
    }

    // Display all items to start
    listingFilters.listingElementList.forEach((listingElement) => {
      listingElement.classList.add('active');
      listingElement.classList.add('display');
    });

    filterElementList.forEach((filterElement) => {
      // Add click event listener for filter item selection
      filterElement.addEventListener(
        'click',
        (e) => {
          listingFilters.handleClick(e, filterElementList, listingFilters.listingElementList);
        },
        false
      );
    });
  },

  handleClick: (e, filterElementList, listingElementList) => {
    listingFilters.updateFilterClasses(e, filterElementList);
    listingFilters.updateFilters(e, filterElementList);
    listingFilters.updateDisplayedItems(listingElementList);
    listingFilters.checkResults(listingElementList);
  },

  updateFilterClasses: (e, filterElementList) => {
    // Add/Remove active class from items
    // Checks if click is on Single Filter
    if (
      e.target.closest('li').parentElement.classList.contains(`category-filter`) ||
      e.target.closest('li').parentElement.classList.contains(`title-filter`)
    ) {
      filterElementList.forEach((filterElement) => {
        filterElement.classList.remove('active');
      });
      //Checks if click is on Multiple Filter
    } else if (e.target.closest('li').parentElement.classList.contains('category-filter')) {
      listingFilters.handleTitlesFilter(e, filterElementList);
    }
    // // Add Active Class if filter item is not already Active
    if (!e.target.closest('li').classList.contains('active')) {
      e.target.closest('li').classList.add('active');
      //   // Else Remove active class if it is already there.
    } else {
      e.target.closest('li').classList.remove('active');
    }
    //If all other filters are removed, return to all-titles
    if (
      !Array.from(filterElementList).some((filterElement) => {
        filterElement.classList.contains('active');
        return false;
      })
    ) {
      // document.querySelector('[data-id="all-titles"]').classList.add('active');
    }
  },

  handleTitlesFilter: (e, filterElementList) => {
    // If All Items is selected, remove other filters
    if (e.target.dataset.id === 'all-titles') {
      filterElementList.forEach((filterElement) => {
        filterElement.classList.remove('active');
      });
      // If a different Filter is selected remove all-titles Filter
    } else {
      filterElementList.forEach((filterElement) => {
        if (filterElement.dataset.title === 'all-titles') {
          filterElement.classList.remove('active');
        }
      });
    }
  },

  updateFilters: (e, filterElementList) => {
    // Add/Remove filters from title-filter List
    if (
      e.target.closest('li').parentElement.classList.contains(`category-filter`) ||
      e.target.closest('li').parentElement.classList.contains(`title-filter`)
    ) {
      // Clear current filter list
      listingFilters.categoryFilter = [];
      listingFilters.titleFilter = [];

      // Iterate over filter items and push them to filter list if they are active.
      filterElementList.forEach((filterElement) => {
        if (filterElement.classList.contains('active')) {
          listingFilters.categoryFilter.push(filterElement.dataset.category);
          listingFilters.titleFilter.push(filterElement.dataset.title);
        }
      });
    }
  },

  updateDisplayedItems: (listingElementList) => {
    // Iterate over displayed items
    listingElementList.forEach((listingElement) => {
      listingElement.classList.remove('active');

      // console.log('test', currentItemTitleValue);

      //Check if Array of tags matches any item in the Array of filters
      if (
        listingFilters.titleFilter.some((item) =>
          listingElement.getAttribute(`data-titles`).includes(item)
        ) ||
        listingFilters.titleFilter.includes('all-titles')
      ) {
        // If an item matches add active class
        setTimeout(() => listingElement.classList.add('display'), 600);
        setTimeout(() => listingElement.classList.add('active'), 650);
      } else {
        // If no item matches remove active class
        setTimeout(() => listingElement.classList.remove('display'), 675);
      }
    });
  },

  checkResults: (listingElementList) => {
    const result = listingElementList.filter((listingElement) =>
      listingElement.classList.contains('active')
    );
    const listingContainer = document.querySelector('.listing-container');
    const listingWrapper = document.querySelector('.listing-wrapper');

    if (
      result.length === 0 &&
      parseInt(listingWrapper.dataset.currentpage) * 6 <= listingWrapper.dataset.totalitems
    ) {
      listingFilters.getMoreAjax();
    } else {
      // When response is returned, set sending state to false.
      // Get and remove loading spinner when response is received.
      const spinner = listingContainer.querySelector('.spinner');
      setTimeout(() => {
        if (spinner) {
          listingContainer.removeChild(spinner);
        }
        listingFilters.sending = false;
      }, 650);
    }
  },

  getMoreAjax: () => {
    const listingWrapper = document.querySelector('.listing-wrapper');
    const listingContainer = document.querySelector('.listing-container');
    // Get post type from dataset
    const postType = listingContainer.dataset.posttype;
    let currentPage = parseInt(listingWrapper.dataset.currentpage);
    const featuredPost = document.querySelector('.featured-image').dataset.featured;
    // Set data for AJAX call
    const callData = {
      action: 'loadMore',
      post_type: postType,
      offset: 3 * currentPage,
      featured_post: featuredPost,
    };
    $.ajax({
      url: ajaxPath.admin_path,
      data: callData,
      type: 'POST',
      beforeSend() {
        currentPage = Number(currentPage) + 1;
        if (!listingFilters.sending) {
          // Insert loading spinner as visual indication to user.
          listingContainer.insertAdjacentHTML(
            'beforeend',
            `<div class="spinner">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
              </div>`
          );
          // Set sending state to true.
          listingFilters.sending = true;
        }
      },
      success(response) {
        // Insert query response at bottom of container element.
        listingWrapper.insertAdjacentHTML('beforeend', response);
        const listingElementList = Array.from(
          document.querySelectorAll('.listing-container .news-item')
        );
        //sliders.initListingGalleries();
        listingElementList.forEach((listingElement) => {
          const newElements = [];
          if (!listingFilters.listingElementList.includes(listingElement)) {
            newElements.push(listingElement);
            listingFilters.updateDisplayedItems(newElements);
            newElements.forEach((element) => {
              listingFilters.listingElementList.push(element);
            });
          }
        });
        // Increase page count to represent current page of items.
        listingWrapper.dataset.currentpage = currentPage;
        listingFilters.checkResults(listingElementList);
      },
    });
  },
};

export default listingFilters;
